export default "__VITE_PUBLIC_ASSET__3c47062f__"